<template>
  <section class="section section-shaped section-lg my-0">
    <div class="shape shape-style-1 bg-gradient-default">
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
    </div>
    <div class="container pt-lg-md">
      <div class="row justify-content-center">
        <div class="col-lg-5">
          <card type="secondary" shadow
                header-classes="bg-white pb-5"
                body-classes="px-lg-5 py-lg-5"
                class="border-0">
            <template>
              <div v-if="login_errado" class="alert alert-danger" role="alert">
                Número de inscrição ou CPF inválido.
              </div>
              <div class="text-muted text-center mb-3">
                <small>Entre com:</small>
              </div>
              <div class="btn-wrapper text-center">
              </div>
            </template>
            <template>
              <form @submit.prevent="envia_login" role="form">
                <base-input v-model="username" alternative
                            class="mb-3"
                            v-mask="'#######-#'"
                            placeholder="Número de inscrição"
                            addon-left-icon="ni ni-single-02">
                </base-input>
                <base-input v-mask="'###.###.###-##'" v-model="password" alternative

                            placeholder="CPF"
                            addon-left-icon="ni ni-badge">
                </base-input>

                <div class="text-center">
                  <base-button native-type="submit" type="primary" class="my-4">Entrar</base-button>
                </div>
              </form>
            </template>
          </card>
          <div class="row mt-3">
            <div class="col-6">
              <a href="#" class="text-light">
                <!--                <small>Esqueci minha senha</small>-->
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import axios from 'axios';
import {useRouter} from 'vue-router';
import Vue from 'vue'
import vueCrypt from 'vue-crypt'
import {cpf} from "cpf-cnpj-validator";

export default {
  name: 'Login',
  data() {
    return {
      username: '',
      password: '',
      login_errado: false,
      logins: [{cpf: 321., num_cand: 123}]
    }
  },
  methods: {
    envia_login: async function () {

      const encryptedText = this.CryptoJS.AES.encrypt("Hi There!", 'secret key 123').toString()
      const decryptedText = this.CryptoJS.AES.decrypt('U2FsdGVkX1+rGzJrqd1xvB4s0Sxxmcl9dbo4sUwcMsE=', 'secret key 123').toString(this.CryptoJS.enc.Utf8)

      const encrypt = (texto) => {
        return this.CryptoJS.AES.encrypt(texto, 'yqKdRqWEAywufSJCZpvPUF5e929UKqMh5eh7AMP5Xpv2FrmdpFeSsnVkyTGvrhPRUG48tZtn32sEGz2R8tDrGcR6wTyYwhdCEvZxbdW42SYpKF7HvrW2XK6zjuWX9946tTx5RhycNDEW8uS475mRVNASZ4CW4v4RhBS5SYHCNHc6DjpwpzWcwuMvTQzCBzMtGbXF8ud4qXhcXnwAQ3xef2tQz3ZeBjvhu32zNGY5PXem92HX3MLRhuw78TqUVsUT').toString()
      }
      const decrypt = (texto) => {
        return this.CryptoJS.AES.decrypt(texto, 'yqKdRqWEAywufSJCZpvPUF5e929UKqMh5eh7AMP5Xpv2FrmdpFeSsnVkyTGvrhPRUG48tZtn32sEGz2R8tDrGcR6wTyYwhdCEvZxbdW42SYpKF7HvrW2XK6zjuWX9946tTx5RhycNDEW8uS475mRVNASZ4CW4v4RhBS5SYHCNHc6DjpwpzWcwuMvTQzCBzMtGbXF8ud4qXhcXnwAQ3xef2tQz3ZeBjvhu32zNGY5PXem92HX3MLRhuw78TqUVsUT').toString(this.CryptoJS.enc.Utf8);
      }

      const gera_file_name = (cpf, num_cand) => {

        let candidato = {CPF: cpf, NUMEROINSC: num_cand}
        let cod_projeto = '2106_pt'
        let codigo_meio = candidato.CPF.replace(/\./g, '').replace('-', '') * 7919;
        codigo_meio = codigo_meio.toString()

        let codigo_arquivo = parseInt(codigo_meio.substring(0, 5)) * parseInt(candidato.NUMEROINSC.replace('-', '')) * 13 + '_'
            + String.fromCharCode(65 + parseInt(codigo_meio[3]))
            + String.fromCharCode(parseInt(codigo_meio[1] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[1]))
            + String.fromCharCode(parseInt(codigo_meio[4] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[5]))
            + String.fromCharCode(parseInt(codigo_meio[3] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[2]))
            + String.fromCharCode(parseInt(codigo_meio[7] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[7]))
            + '-'
            + String.fromCharCode(parseInt(codigo_meio[0] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[11]))
            + String.fromCharCode(parseInt(codigo_meio[1] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[9]))
            + String.fromCharCode(parseInt(codigo_meio[5] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[4]))
            + String.fromCharCode(parseInt(codigo_meio[8] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[5]))
            + String.fromCharCode(parseInt(codigo_meio[3] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[8]))
            + '_'
            + String.fromCharCode(parseInt(codigo_meio[2] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[3]))
            + String.fromCharCode(parseInt(codigo_meio[8] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[4]))
            + String.fromCharCode(parseInt(codigo_meio[3] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[6]))
            + String.fromCharCode(parseInt(codigo_meio[6] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[2]))
            + String.fromCharCode(parseInt(codigo_meio[3] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[11]))
            + String.fromCharCode(parseInt(codigo_meio[8] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[9]))

        return codigo_arquivo + '.pdf';
      }


      let cands =
[{"num_cand":"U2FsdGVkX18ztvQOv8OgR70Zuu7uoLQExROKfQObl4c=","cpf":"U2FsdGVkX1+F+49JAS2s0oIEvEren+xWNjG7gcRpQpE="},{"num_cand":"U2FsdGVkX1/2cyh39hNsa9MIJtBh5OL0rLttUf3otq4=","cpf":"U2FsdGVkX18PBv9VHuWCTVjwzgEXn4FMoFxx6nze+wE="},{"num_cand":"U2FsdGVkX19vVZ8LgXq4ZAr2y87e0Y/WlTY9gL21YnU=","cpf":"U2FsdGVkX1+SMtLxKk/59ktOwgSAhQc+OCvsMUX9f0U="},{"num_cand":"U2FsdGVkX1/tvlVr4jNXdN4V1d7l2yPOIr7+o/T3ln8=","cpf":"U2FsdGVkX18vu1Trlbanak93FMPmLjiRejnssqn23Z4="},{"num_cand":"U2FsdGVkX1/AONsajmayMsNmQrYOBxusA3knL2F1+Bo=","cpf":"U2FsdGVkX18/+OW378iz7O+Re9tmb4mIxB63Wo2VrIw="},{"num_cand":"U2FsdGVkX19hiMcKn3EPsoSWCoViBe4uQfgjDJg72bk=","cpf":"U2FsdGVkX1/ZnwJz+ogmAo+/ms/RPL4BRBlMWsFCEaI="},{"num_cand":"U2FsdGVkX19zOs+noYI/BZlJTsAruMwWgd1bCrhyIo4=","cpf":"U2FsdGVkX1+Loif3wAUOIxQ5CgkOHU1ZK9W4Vfq70/I="},{"num_cand":"U2FsdGVkX195P+XUZgx2fhA0cK208Dc1UTEtsaU0kPE=","cpf":"U2FsdGVkX19tWN/BkdkyDJCCnER/7ze4SESf61v/nD8="},{"num_cand":"U2FsdGVkX1+8GwuPEA7R2YesIUAXnyY2OYZ27PlXaDg=","cpf":"U2FsdGVkX18GiHuZplAqGw2tgsZbMbCyGREqHLt7p5E="},{"num_cand":"U2FsdGVkX1/dVcukHhbtDEDnYRbBXWU6Nrj2b6Y8qmo=","cpf":"U2FsdGVkX1+ToRiGw0XXTm37xzBpsdlRB01hlmaVUts="},{"num_cand":"U2FsdGVkX1+D3MBvXhQJRAVnxdJzilYyamrJfb+NWe8=","cpf":"U2FsdGVkX1+XtUQpFV189vudqIgfPaLH/yrQ+5tFaxc="},{"num_cand":"U2FsdGVkX1/trTuj9xVd4GYWDq5CNvE38d+E7Mt8aKI=","cpf":"U2FsdGVkX1+5qEFRjeNZpxQJ+GD4zCC/mgPsbvnsy+c="},{"num_cand":"U2FsdGVkX1/BDLWSI8gtJOh62Lj4Jd23EXSuXjV6oYw=","cpf":"U2FsdGVkX1+5lhsIdP+wht13gfMBW/dfi+GXCv8pQH4="},{"num_cand":"U2FsdGVkX1+UeBnt8MVUYKsUVjsz+9fZWy5G0AGpVWg=","cpf":"U2FsdGVkX19C94ppqlgvdyzcnGsdNfsC+lSrKDhILKg="},{"num_cand":"U2FsdGVkX19/8wukNB/mkEDx9G1WsK99HS4PBZMn3Ww=","cpf":"U2FsdGVkX194481WZHiDVOnO/j2YP5FKGavXJppRFvs="},{"num_cand":"U2FsdGVkX1/qgJAqK8JUGS6dAsjy8JgrH4XbXTfcV2M=","cpf":"U2FsdGVkX1+eopPDaHW4GoRCgmXIYPw+Tlwcl9kt6yw="},{"num_cand":"U2FsdGVkX1+fYIHJf74CRqK/stBKFMUFU2N/Dd3J/2s=","cpf":"U2FsdGVkX1/z/yuxrcjDERzNlM8+zkJXZJb6MxuJfXo="},{"num_cand":"U2FsdGVkX19fr+QJUVnV3yqCDoEqjkXNhW+11HwGl5A=","cpf":"U2FsdGVkX1+PFVa4Pj0EfI62NvPU5R/NeISzZQZba3o="}]
      try {
        let concurso = this.$route.params.concurso;
        localStorage.setItem('concurso', concurso);

        for (let login of cands) {
          let num_cand_decripted = decrypt(login.num_cand);
          let cpf_decripted = decrypt(login.cpf);

          // console.log(num_cand_decripted,cpf_decripted)
          if (num_cand_decripted == this.username && cpf_decripted == this.password) {
            console.log(`Logged`)
            let nome_arquivo = (gera_file_name(cpf_decripted, num_cand_decripted))
            nome_arquivo = nome_arquivo.replace(/\x00/g, '-');


            // alert(`Logou`);
            let url = (`https://fs.ibfc.org.br/arquivos/2220/rec_isenc/${nome_arquivo}`)
            return window.location = url;
          }
        }

        throw new Error(`Login inválido`);


      } catch (error) {
        console.log(error);
        this.login_errado = true;
      }
    }
  }
};
</script>
<style>
</style>
